import { createStore } from "redux";
import rootReducer from "./Reducer";

const initialState = {
  Header: "Uptake Medical",
  showModal: false,
  sidebarRoute: "",
  seconds: 1500,
  time: {},
  role:"",
};

const store = createStore(rootReducer, initialState);
export default store;
